<body>
  <div class="modal modalCenter" id="forgotPassword" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content modal-sm">
        <div class="forgotpass-wrap">
          <div class="image">
            <img class="lazyload" data-src="../assets/images/section/login.png" src="../assets/images/section/login.png"
              alt="">
          </div>
          <div class="content">
            <div class="close-form">
              <a href="#" class="btn-hide-popup" data-bs-dismiss="modal"><i class="icon-close"
                  aria-hidden="true"></i></a>
            </div>
            <h4 class="title">
              Welcome to GoGo Money Maker
            </h4>
            <form id="form-forgotpass" class="form-forgotpass" [formGroup]="passwordForgotForm">
              <div class="cols mb-20">
                <fieldset>
                  <label for="emailForgot">Email address</label>
                  <input id="emailForgot" type="email" required placeholder="Your email" name="emailForgot"
                    formControlName="emailAddress">
                </fieldset>
              </div>
              <br><br>
              <button type="button" class="btn-login tf-btn full-w" (click)="onForgot()">
                Start restore password
              </button>
            </form>
            <p class="bottom-form">
              Not registered yet?
              <a href="javascript:void(0);" class="type-main-color" (click)="openRegisterModal()">
                Create a FREE Account
              </a>
              and start playing!
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>
